const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  swiperReinit: 'swiper:reInit',
  swiperAfterInit: 'swiper:afterInit',
  swiperSlideChange: 'swiper:slideChange',
  swiperImageInit: 'swiper:imageInit',
};

const BREAKPOINTS = {
  tablet: 750,
  desktop: 990,
  desktop_medium: 1200,
  desktop_large: 1440,
};
